
import React, { useEffect } from "react";
import {
  AddInputField,
  AddProfileTitle,
  UpdateButton,
  DropdownField,
} from ".";
import { Grid } from "@mui/material";
import "../../../Styles/profileDetails.scss";
import { useForm } from "react-hook-form";
import profile from "../../../Assests/icons/profile.png";
import { useDispatch, useSelector } from "react-redux";
import { updateDistributerDetails } from "../../../redux/reducers/profileSettingReducer";
import { validationMessage } from "../../../constants/textConstants";


export default function PersonalDetailsForm() {
    let dispatch = useDispatch();
    const {
        register,
        handleSubmit,
        formState: { errors },
        reset,
    } = useForm({
        defaultValues: {
          firstName: "",
          lastName: "",
          email: "",
          phone: "",
          addressLine1: "",
          addressLine2: "",
          city: "",
          state: "",
          zip: "",
          countryId: "",
        },
    });
    const distributorDetails = useSelector(
        (state) => state.profileSettings?.getDistributorDetailReq?.response || []
    );
    let countries = useSelector((state) => state.getCountries?.countries?.response);
    
    // Update form default values 
    useEffect(() => {
    if (distributorDetails?.length > 0) {
        const distributor = distributorDetails[0];
        reset({
            firstName: distributor?.firstName || "",
            lastName: distributor?.lastName || "",
            phone: distributor?.phone || "",
            email: distributor?.email || "",
            addressLine1: distributor?.address1 || "",
            addressLine2: distributor?.address2 || "",
            city: distributor?.city || "",
            state: distributor?.state || "",
            zipCode: distributor?.zipCode || "",
            countryId: distributor?.countryId || 0,
        });
    }
    }, [distributorDetails, reset]);

    const onSubmit = (data) => {
        let {email, ...finaldata} = data;
        dispatch(updateDistributerDetails({data: finaldata, dispatch}))
    };

    return (
      <div className="addVideo_container">
        <Grid
          container
          spacing={2}
        >
          <AddProfileTitle label={"Personal Info"} icon1={profile} icon2={""} />

          <AddInputField
            label={"First Name"}
            isRequired={true}
            sizelg={4}
            sizemd={6}
            sizesm={12}
            name={"firstName"}
            register={register}
            errors={errors}
            required={validationMessage.first_name_req}
          />
          <AddInputField
            label={"Last Name"}
            isRequired={true}
            sizelg={4}
            sizemd={6}
            sizesm={12}
            name={"lastName"}
            register={register}
            errors={errors}
            required={validationMessage.last_name_req}

          />
          <AddInputField
            label={"Phone Number"}
            isRequired={true}
            sizelg={4}
            sizemd={6}
            sizesm={12}
            name={"phone"}
            isNumberField={true}
            register={register}
            errors={errors}
            required={validationMessage.phone_req}
            pattern={{
              value: /^[0-9]{10}$/,
              message: "Invalid phone number format",
            }}
          />
          <AddInputField
            label={"Email Address"}
            isRequired={true}
            sizelg={4}
            sizemd={6}
            sizesm={12}
            name={"email"}
            register={register}
            errors={errors}
            disabled={true}
            required={validationMessage.email_req}
          />
          <AddInputField
            label={"Address Line 1"}
            isRequired={true}
            sizelg={4}
            sizemd={6}
            sizesm={12}
            name={"addressLine1"}
            register={register}
            errors={errors}
            required={validationMessage.address_req}
          />
          <AddInputField
            label={"Address Line 2"}
            isRequired={false}
            sizelg={4}
            sizemd={6}
            sizesm={12}
            name={"addressLine2"}
            register={register}
            errors={errors}
          />
          <AddInputField
            label={"City"}
            isRequired={true}
            sizelg={4}
            sizemd={6}
            sizesm={12}
            name={"city"}
            register={register}
            errors={errors}
            required={validationMessage.city_req}
          />
          <AddInputField
            label={"State"}
            isRequired={true}
            sizelg={4}
            sizemd={6}
            sizesm={12}
            name={"state"}
            register={register}
            errors={errors}
            required={validationMessage.state_req}
          />
          <AddInputField
            label={"Zip / Postal Code"}
            isRequired={true}
            sizelg={4}
            sizemd={6}
            sizesm={12}
            name={"zipCode"}
            register={register}
            errors={errors}
            required={validationMessage.postalCode_req}
          />
          <DropdownField
            label="Country"
            sizelg={4}
            sizemd={6}
            sizesm={12}
            name="countryId"
            isDropdown={true}
            dropdownOptions={countries?.map((e) => {
                return {value: e.id, label: e.name};
            })}
            isRequired={true}
            register={register}
            errors={errors}
            defaultValue={distributorDetails[0]?.countryId}
            required={validationMessage.country_req}
          />

          <UpdateButton label="Update" onClick={handleSubmit(onSubmit)}/>
        </Grid>
        </div>
    );
}